import React from 'react'
import { makeStyles } from '@mui/styles';
import { withRouter } from 'react-router-dom';

const ModalAge = (props) => {
    
    const { setOpenAgeModal } = props;

    const useStyles = makeStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',

        },
        header: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'start'
        },
        header_content: {
            color: '#055c9d',
            fontSize: 85,
            margin: 0
        },
        header_img: {
            objectFit: 'contain',
            marginTop: 5,
            '&:hover': {
                cursor: 'pointer'
            }
        },
        header_img_hidden: {
            objectFit: 'contain',
            visibility: 'hidden'
        },
        content: {
            display: 'flex',
            width: '65%',
            flexDirection: 'column',
            alignItems: 'center'
        },
        txt_center: {
            textAlign: 'center',
            fontSize: 'medium',
            color: 'black',
            fontWeight: '500',
            letterSpacing: '1px'
        },
        container_buttons: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '5%'
        },
        btn_left: {
            width: '45%',
            border: 'none',
            borderRadius: 20,
            color: 'white',
            background: '#68bbe3',
            fontWeight: 'bolder',
            padding: '3%',
            fontSize: 'medium',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        btn_right: {
            width: '45%',
            border: 'none',
            borderRadius: 20,
            color: 'white',
            background: '#055c9d',
            fontWeight: 'bolder',
            padding: '3%',
            fontSize: 'medium',
            '&:hover': {
                cursor: 'pointer'
            }
        }
    })

    const styles = useStyles()

    const goToProfile = () => {
        props.history.push('/profile')
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={require('../../assets/xmodal.png').default} alt="cerrar modal" width={'25px'} className={styles.header_img_hidden}/>
                <h1 className={styles.header_content}>+18</h1>
                <img src={require('../../assets/xmodal.png').default} alt="cerrar modal" width={'25px'} className={styles.header_img} onClick={() => setOpenAgeModal(false)}/>
            </div>
            <h2 style={{ color: '#055c9d', fontSize: 30, marginBottom: 15 }}>Mayoría de edad</h2>
            <div className={styles.content}>
                <span className={styles.txt_center}>
                    Se requiere la mayoría de edad para completar el registro. 
                    La información proporcionada no se ajusta a las preferencias de Shield.
                </span>
                <div className={styles.container_buttons}>
                    <button className={styles.btn_left} onClick={goToProfile}>Cambiar datos</button>
                    <button className={styles.btn_right} onClick={() => setOpenAgeModal(false)}>Cancelar</button>
                </div>
            </div>
        </div>
    )
}

export default withRouter(ModalAge)